export default function registroActividad(uuid) {
  // Llamar a la función para registrar la entrada
  const xhr = new XMLHttpRequest();
  xhr.open("POST", "./Request/enc/registroActividad.php", true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  
  xhr.onload = function () {
    if (xhr.status === 200) {
      //console.log("Registro exitoso:", xhr.responseText);
    } else {
      console.error("Error en la petición:", xhr.status, xhr.statusText);
    }
  };

  xhr.onerror = function () {
    console.error("Error en la solicitud.");
  };
  
  // Enviar el ID al servidor
  xhr.send(`id=${encodeURIComponent(uuid)}`);
}